import React, { useState, useEffect } from 'react';
import SrchSub from '../SrchSub';
import { setup } from 'src/lib/endpoints';
import { useRequest, useNotif } from 'src/hooks';

const SubAccount = ({ data, onChangeField }) => {
  const request = useRequest();
  const notif = useNotif();
  const ixSubType = data.ixSubType;
  const sSubType = data.sSubType;
  const varType = data.type ?? 'json';
  const [subList, setSubList] = useState([]);

  const [selected_ixSub, setSelected_ixSub] = useState(data?.value ?? 0);
  const [selected_sSub, setSelected_sSub] = useState(data?.value?.sSub ?? 0);
  const handleChangeSrchSub = ({ ixSub, sSub, ...rest }) => {
    setSelected_sSub(sSub);
    setSelected_ixSub(ixSub);
    if (varType == 'json') {
      onChangeField({
        target: {
          name: data.fld,
          value: {
            ixSub,
            sSub
          }
        }
      });
    } else if (varType == 'int') {
      onChangeField({
        target: {
          name: data?.fld || '',
          value: ixSub ?? 0
        }
      });
    }
  };

  // set ssub based on ixSub
  useEffect(() => {
    if (varType != 'int') {
      return;
    }
    if (subList.length == 0) {
      return;
    }
    const found = subList.find(
      item => Number(item.ixSub) === Number(selected_ixSub)
    );
    const subTitle = found ? found.sub_title : '';
    setSelected_sSub(subTitle);
  }, [subList, data]);

  // fetch all sub accounts of ixSubType
  useEffect(() => {
    if (varType != 'int') {
      return;
    }
    let cancel = () => {};

    (async function() {
      const res = await request.post(
        setup.sub.list,
        {
          ixSubType: ixSubType,
          q: ''.trim(),
          showInactive: false
        },
        function(c) {
          cancel = c;
        }
      );
      if (res.success) setSubList(res.data?.sub_list || []);
      else if (!res.isCancelled) {
        notif.error('Error fetching sub accounts');
      }
    })();

    return () => cancel();
  }, []);

  return (
    <SrchSub
      ixSubType={ixSubType}
      sSubType={sSubType}
      fld={data.fld}
      error={data?.error ?? false}
      errorMessage={data?.errorMessage ?? ''}
      size={data?.rest?.size ?? 'medium'}
      placeholder={data?.label ?? 'Select Account'}
      selectedSub={selected_sSub ?? data?.value?.sSub ?? ''}
      handleSubSelectRoot={handleChangeSrchSub}
      {...(data?.rest ?? {})}
    />
  );
};

export default SubAccount;
